export default __webpack_public_path__ + "static/cruiselines-royal-ship-1-760f9759a2132bb3d8485a830d2a09c6.jpg";